var _defs, _path, _rect, _line, _path2, _path3, _line2, _circle, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWebbutv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 79.16 64.31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        stroke-width: 3px;\n      }\n\n      .cls-1, .cls-2 {\n        fill: none;\n        stroke: #2e002f;\n        stroke-miterlimit: 10;\n      }\n\n      .cls-3 {\n        fill: #ffa0ff;\n      }\n\n      .cls-2 {\n        stroke-linecap: round;\n        stroke-width: 1.5px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M63.71,4.91c-4.58-2.15-9.93-3.85-15.03-3.92-.81-.01-1.6.05-2.37.16-4.05-1.7-8.81-1.57-12.7.82-5.81,3.57-8.82,11.19-10.17,17.71-2.32,2.43-4.52,4.97-6.57,7.57-2.51,1.56-4.92,3.27-7.24,5.14-.34.28-.6.59-.8.91-2.93,1.39-5.51,3.53-7.22,6.42-2.01,3.38-1.96,7.14-.79,10.58,0,.06,0,.12,0,.18.08,8.08,7.54,13.1,15.2,13,7.65,2.84,16.06-1.89,22.7-8.06,5.79-4.36,11.51-8.81,17.15-13.37,1.78-.6,3.59-1.23,5.35-1.96,6.63-2.43,12.96-6.56,16.24-12.55,2.18-3.98,2.33-8.47.06-12.05-1.42-2.25-3.5-3.84-5.86-5.05-2.27-2.3-4.99-4.13-7.95-5.51Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 4.27,
    y: 2.03,
    width: 64.44,
    height: 54.37,
    rx: 7.84,
    ry: 7.84
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 38.67,
    y1: 22.85,
    x2: 33.77,
    y2: 43.69
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M43.82,27.86l5.74,5.02s.02.05,0,.07l-5.02,5.74"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M28.63,27.86l-5.74,5.02s-.02.05,0,.07l5.02,5.74"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 4.27,
    y1: 15.36,
    x2: 68.71,
    y2: 15.36
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 13.89,
    cy: 9,
    r: 2.22
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 21.74,
    cy: 9,
    r: 2.22
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 29.6,
    cy: 9,
    r: 2.22
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebbutv);
export default __webpack_public_path__ + "static/media/webbutv.39ade948daa5a67dd75714257cb2e73f.svg";
export { ForwardRef as ReactComponent };